export enum CifaStatusEnum {
    NOT_STARTED = 'NÃO INICIADO',
    PENDING = 'PENDENTE',
    WAITING_FOR_APPROVAL = 'AGUARDANDO APROVAÇÃO',
    APPROVED = 'APROVADO',
    REJECTED = 'REJEITADO',
}

export enum StatusCifaTextEnum {
    NOT_STARTED = 'Aguardando Preenchimento',
    PENDING = 'Preenchimento Concluído',
    WAITING_FOR_APPROVAL = 'Aguardando Aprovação',
    APPROVED = 'Aprovado',
    REJECTED = 'Rejeitado',
}